import React from "react"
import { Link, useLocation } from "react-router-dom"

// Comps
import ParticipantSelector from "./components/ParticipantSelector"
import MyParticipantsSummary from "../MyParticipantsSummary"
import AllParticipantsSummary from "../AllParticipantsSummary"

export default function ParticipantSidebar() {
  const location = useLocation()

  const ALL_PARTICIPANTS_PATH = "/participant/list"
  const MY_PARTICIPANTS_PATH = "/my-participants"
  const currentPath = location.pathname

  // Function to determine which summary component to display based on the current route
  const handleSummary = () => {
    switch (currentPath) {
      case ALL_PARTICIPANTS_PATH:
        return <AllParticipantsSummary />
      case MY_PARTICIPANTS_PATH:
        return <MyParticipantsSummary />
      default:
        return null
    }
  }

  return (
    <>
      {/* Summary Section */}
      {handleSummary()}

      {/* Active Participants Section */}
      <h3 className="sidebar-section-title">
        Active Participants
      </h3>

      {/* Conditionally render the "New Intake Session" button only on the all participants and my participants pages */}
      {[ALL_PARTICIPANTS_PATH, MY_PARTICIPANTS_PATH].includes(currentPath) && (
        <Link
          to="/form/intake_session/1"
          className="btn"
          style={{
            width: "100%",
            marginBottom: "12px",
            justifyContent: "center",
          }}
        >
          <i className="pi pi-plus" />
          New Intake Session
        </Link>
      )}

      {/* Participant Selector Section */}
      <ParticipantSelector />
    </>
  )
}
